/**
 * tag接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const tagEndpoints: ApiEndpoint[] = [
  {
    id: 'tag-list',
    method: 'GET',
    path: '/api/tags',
    name: '获取标签列表',
    description: '分页查询标签列表',
    category: API_CATEGORIES.TAG,
    queryParams: [
      { name: 'page', type: 'number', required: false, description: '页码', example: '1' },
      { name: 'limit', type: 'number', required: false, description: '每页条数', example: '10' },
      { name: 'search', type: 'string', required: false, description: '搜索关键词' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '标签列表' },
      { name: 'pagination', type: 'object', description: '分页信息' }
    ],
    requiredPermission: 'msspace:tags:view',
    responseExample: JSON.stringify({
      success: true,
      data: [
        {
          id: "fc6a3439-1668-44bb-b5db-4d595216c984",
          name: "建筑",
          icon: "<svg>...</svg>",
          createdAt: "2025-10-07T11:34:41.701Z",
          updatedAt: "2025-10-07T11:34:41.701Z"
        }
      ],
      pagination: {
        total: 10,
        page: 1,
        limit: 10
      },
      message: "查询成功"
    }, null, 2)
  },
  {
    id: 'tag-create',
    method: 'POST',
    path: '/api/tags',
    name: '创建标签',
    description: '创建新的标签',
    category: API_CATEGORIES.TAG,
    bodyParams: [
      { name: 'name', type: 'string', required: true, description: '标签名称（1-50字符）' },
      { name: 'icon', type: 'string', required: false, description: 'SVG图标字符串（最大10KB）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '创建的标签信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:tags:create',
    responseExample: JSON.stringify({
      success: true,
      data: {
        id: "fc6a3439-1668-44bb-b5db-4d595216c984",
        name: "新标签",
        icon: "<svg>...</svg>",
        createdAt: "2025-10-07T11:34:41.701Z",
        updatedAt: "2025-10-07T11:34:41.701Z"
      },
      message: "标签创建成功"
    }, null, 2)
  },
  {
    id: 'tag-detail',
    method: 'GET',
    path: '/api/tags/:id',
    name: '获取标签详情',
    description: '根据ID获取标签详细信息',
    category: API_CATEGORIES.TAG,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '标签ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '标签详细信息' }
    ],
    requiredPermission: 'msspace:tags:view'
  },
  {
    id: 'tag-update',
    method: 'PUT',
    path: '/api/tags/:id',
    name: '更新标签',
    description: '更新标签信息',
    category: API_CATEGORIES.TAG,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '标签ID（UUID）' }
    ],
    bodyParams: [
      { name: 'name', type: 'string', required: false, description: '标签名称（1-50字符）' },
      { name: 'icon', type: 'string', required: false, description: 'SVG图标字符串（最大10KB）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '更新后的标签信息' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:tags:update'
  },
  {
    id: 'tag-delete',
    method: 'DELETE',
    path: '/api/tags/:id',
    name: '删除标签',
    description: '根据ID删除标签',
    category: API_CATEGORIES.TAG,
    pathParams: [
      { name: 'id', type: 'string', required: true, description: '标签ID（UUID）' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'message', type: 'string', description: '响应消息' }
    ],
    requiredPermission: 'msspace:tags:delete'
  },
  {
    id: 'tag-search',
    method: 'GET',
    path: '/api/tags/search/:keyword',
    name: '搜索标签',
    description: '根据关键词搜索标签',
    category: API_CATEGORIES.TAG,
    pathParams: [
      { name: 'keyword', type: 'string', required: true, description: '搜索关键词' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'array', description: '搜索结果' }
    ],
    requiredPermission: 'msspace:tags:view'
  },
  {
    id: 'tag-statistics',
    method: 'GET',
    path: '/api/tags/statistics',
    name: '获取标签统计',
    description: '获取标签统计信息',
    category: API_CATEGORIES.TAG,
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data', type: 'object', description: '统计信息' }
    ],
    requiredPermission: 'msspace:tags:view'
  },
];
